module.exports = __webpack_public_path__ + "static/media/anyone-online-sellers.a4ce7401.jpg";